<header class="topbar sticky-top d-flex align-items-center justify-content-between flex-shrink-0 px-3 px-md-4 px-lg-5">
  <!-- Mobile Menu Toggle -->
  <button class="shell-btn d-md-none p-2 fs-4" (click)="onToggleSidebar()">
    <i class="bi bi-list"></i>
  </button>

  <!-- Page Title / Breadcrumbs (can be added later) -->
  <div class="flex-grow-1 d-flex align-items-center">
    <!-- Update Available -->
    <button *ngIf="updateAvailable()" class="update-btn btn btn-primary btn-sm fw-semibold d-flex align-items-center gap-1" (click)="reloadForUpdate()"
      aria-label="Update available" title="A new version is available">
      <i class="bi bi-arrow-repeat"></i>
      <span class="update-text">Update Available</span>
    </button>
  </div>

  <!-- Right Side Actions -->
  <div class="d-flex align-items-center gap-1 gap-md-2">
    <!-- Theme Toggle -->
    <button class="shell-btn theme-toggle-btn fs-5" (click)="toggleTheme()" [attr.aria-label]="'Switch to ' + ((currentTheme$ | async) === 'light' ? 'dark' : 'light') + ' mode'">
      <i class="bi" [ngClass]="(currentTheme$ | async) === 'light' ? 'bi-moon-stars' : 'bi-sun'"></i>
    </button>

    <!-- User Profile Dropdown -->
    <div class="user-menu position-relative" [class.show]="showUserMenu">
      <button class="shell-btn gap-2 p-1" (click)="toggleUserMenu()">
        <i class="bi bi-person-circle fs-4 text-primary"></i>
        <span class="user-name d-none d-sm-inline fw-medium">{{ getUserName() }}</span>
        <i class="bi bi-chevron-down chevron-icon"></i>
      </button>

      <!-- Dropdown Menu -->
      <div class="dropdown-menu top-100 end-0 mt-2" [class.show]="showUserMenu">
        <button class="dropdown-item d-flex align-items-center gap-2 py-2" (click)="goToProfile()">
          <i class="bi bi-person"></i>
          Profile
        </button>
        <button class="dropdown-item d-flex align-items-center gap-2 py-2" (click)="goToSettings()">
          <i class="bi bi-gear"></i>
          Settings
        </button>
        <hr class="dropdown-divider" />
        <button class="dropdown-item d-flex align-items-center gap-2 py-2 text-danger" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
          Logout
        </button>
      </div>
    </div>
  </div>
</header>
